
define(function(){
	// general
	const CommonInspectionCode = require('civicsViews/inspection_request/common/common');
	const CN = require('civicsUtils/constants');
	// collections
	const GenericCollection = require('civicsBase/generic_collection');
	// models
	const InspectionModel = require('civicsModels/inspection_model');
	const ReviewModel = require('civicsModels/review_model');

	var inspectionParse = function (data) {

		// loop thru the data for a given dataType
		for (i = 0; i < data.length; i++) {
            var computedDescription = Handlebars.helpers['global:computedDescription'](data[i].inspectionType.portalDescription, data[i].inspectionType.description);
			data[i].computedDescription = computedDescription;

			// set the displayDate
			var isClosed = data[i].result && data[i].result.trim().length > 0;
			if (isClosed) {
				data[i].displayDate = data[i].resultDateTime;
			} else {
				// call the common helper to get the dates since it has the shared logic
				var psuedoView = {};
				psuedoView.config = {};
				psuedoView.config.INSPECTION_STATE = CN.INSPECTION_STATE();
				psuedoView.config.captureRequestDateToCallDate = App.captureRequestDateToCallDate;
				psuedoView.model = new InspectionModel();
				psuedoView.model.set('scheduledDateTime', data[i].scheduledDateTime);
				psuedoView.model.set('callDateTime', data[i].callDateTime);
				psuedoView.model.set('result', data[i].result);
				psuedoView.model.set('resultDateTime', data[i].resultDateTime);
				psuedoView.model.set('startDateTime', data[i].startDateTime);
				psuedoView.model.set('completedDateTime', data[i].completedDateTime);
				psuedoView.model.set('inspectionHours', data[i].inspectionHours);
				psuedoView.model.set('isPartial', data[i].isPartial);
				var common = CommonInspectionCode.commonHelpers(psuedoView)
				data[i].displayDate = common.getInspectionAssignmentScheduledDate();
				if (data[i].displayDate == '') {
					data[i].displayDate = CN.DATE_TIME_MIN_VAL;
				}
			}
			// if (__DEV__) console.log('inspectionParse data[i].displayDate',data[i].displayDate)
		}
		return data;
	};

	var reviewParse = function (data) {
		// loop thru the data for a given dataType
		for (i = 0; i < data.length; i++) {
            var computedDescription = Handlebars.helpers['global:computedDescription'](data[i].reviewType.portalDescription, data[i].reviewType.description);
			data[i].computedDescription = computedDescription;

			// set the displayDate
			var isClosed = data[i].result && data[i].result.trim().length > 0;
			if (isClosed) {
				data[i].displayDate = data[i].resultDateTime;
			} else {
				var hasScheduledDateTime = data[i].scheduledDateTime && data[i].scheduledDateTime != CN.DATE_TIME_MIN_VAL;
				if (hasScheduledDateTime) {
					data[i].displayDate = data[i].scheduledDateTime;
				} else {
					// While we could set DisplayDate to 'TBD', we set it to '' so that the inbound sort will work.
					// the handlebars template can take care of showing 'TBD'
					data[i].displayDate = CN.DATE_TIME_MIN_VAL;
				}
			}
			// if (__DEV__) console.log('reviewParse data[i].displayDate',data[i].displayDate)
		}
		return data;
	};

	// 2016-08-24 PL:  Note:
	//	The reviews in the dataTypeContext have a field mapping for callDateTime to scheduledDateTime.
	//  This is a workaround because the excludedDataTypes feature isn't currently working for nested conditions.
	//
	//	The layout view adds the "ViewBy" criteria to the filters returned by the FiltersView.
	//  This ViewBy criteria is an OR condition like ...
	//  -	for inspections:  resultDateTime in range OR scheduledDateTime in range OR callDateTime in range
	//  -   for reviews:   resultDateTime in range OR scheduledDateTime in range
	//
	//  Reviews don't have a callDateTime property, but since inspections and reviews share the same filters,
	//  we need to add this field mapping otherwise the API call for reviews will fail on callDateTime.
	//
	//  The OR condition for reviews end up repeating the scheduledDateTime condition ...
	//  -   resultDateTime in range OR scheduledDateTime in range OR scheduledDateTime in range
	//
	//  This workaround may be removed if the excludedDataTypes feature is fixed and the "ViewBy" code in the layout
	//  view is adjusted to use it.
	//
	return GenericCollection.extend({
		dataTypeContext : [{
			type: 'building.Inspection',
			url: 'cdr/inspections/Building',
			model: InspectionModel,
			collectionParse: inspectionParse
		},{
			type: 'building.Review',
			url: 'cdr/reviews/Building',
			model: ReviewModel,
			collectionParse: reviewParse,
			fieldMappings: [{
				appName: 'inspectionType.code',
				svcName: 'reviewType.code'
			},{
				// Workaround mapping
				appName: 'callDateTime',
				svcName: 'scheduledDateTime'
			}]
		},{
			type: 'businessLicense.Inspection',
			url: 'cdr/inspections/BusinessLicense',
			model: InspectionModel,
			collectionParse: inspectionParse,
			fieldMappings: [{
				appName: 'Parcel',
				svcName: ''
			}]
		},{
			type: 'businessLicense.Review',
			url: 'cdr/reviews/BusinessLicense',
			model: ReviewModel,
			collectionParse: reviewParse,
			fieldMappings: [{
				appName: 'inspectionType.code',
				svcName: 'reviewType.code'
			},{
				// Workaround mapping
				appName: 'callDateTime',
				svcName: 'scheduledDateTime'
			},{
				appName: 'Parcel',
				svcName: ''
			}]
		},{
			type: 'codeEnforcement.Inspection',
			url: 'cdr/inspections/CodeEnforcement',
			model: InspectionModel,
			collectionParse: inspectionParse
		},{
			type: 'codeEnforcement.Review',
			url: 'cdr/reviews/CodeEnforcement',
			model: ReviewModel,
			collectionParse: reviewParse,
			fieldMappings: [{
				appName: 'inspectionType.code',
				svcName: 'reviewType.code'
			},{
				// Workaround mapping
				appName: 'callDateTime',
				svcName: 'scheduledDateTime'
			}]
		},{
			type: 'planning.Inspection',
			url: 'cdr/inspections/Planning',
			model: InspectionModel,
			collectionParse: inspectionParse
		},{
			type: 'planning.Review',
			url: 'cdr/reviews/Planning',
			model: ReviewModel,
			collectionParse: reviewParse,
			fieldMappings: [{
				appName: 'inspectionType.code',
				svcName: 'reviewType.code'
			},{
				// Workaround mapping
				appName: 'callDateTime',
				svcName: 'scheduledDateTime'
			}]
		},{
			type: 'project.Inspection',
			url: 'cdr/inspections/Project',
			model: InspectionModel,
			collectionParse: inspectionParse
		},{
			type: 'project.Review',
			url: 'cdr/reviews/Project',
			model: ReviewModel,
			collectionParse: reviewParse,
			fieldMappings: [{
				appName: 'inspectionType.code',
				svcName: 'reviewType.code'
			},{
				// Workaround mapping
				appName: 'callDateTime',
				svcName: 'scheduledDateTime'
			}]
		},{
			type: 'tradeLicense.Inspection',
			url: 'cdr/inspections/TradeLicense',
			model: InspectionModel,
			collectionParse: inspectionParse,
			fieldMappings: [{
				appName: 'Parcel',
				svcName: ''
			},{
 				appName: 'Address',
 				svcName: ''
	 		}]
		},{
			type: 'tradeLicense.Review',
			url: 'cdr/reviews/TradeLicense',
			model: ReviewModel,
			collectionParse: reviewParse,
			fieldMappings: [{
				appName: 'inspectionType.code',
				svcName: 'reviewType.code'
			},{
				// Workaround mapping
				appName: 'callDateTime',
				svcName: 'scheduledDateTime'
			},{
				appName: 'Parcel',
				svcName: ''
			},{
 				appName: 'Address',
 				svcName: ''
	 		}]
		},{
			type: 'use.Inspection',
			url: 'cdr/inspections/Use',
			model: InspectionModel,
			collectionParse: inspectionParse
		},{
			type: 'use.Review',
			url: 'cdr/reviews/Use',
			model: ReviewModel,
			collectionParse: reviewParse,
			fieldMappings: [{
				appName: 'inspectionType.code',
				svcName: 'reviewType.code'
			},{
				// Workaround mapping
				appName: 'callDateTime',
				svcName: 'scheduledDateTime'
			}]
		}]
	});
});
